import React from 'react';
import { useUser } from 'src/context/UserContext';
import { getDisplayRole } from 'src/roles-permissions';
import Icon from "@amzn/awsui-components-core/icon";
import Badge from "@amzn/awsui-components-core/badge";
import { badgeStyles } from 'src/components/shared/design-tokens';
import './Header.scss';

const UserInfo = () => {
    const { user, loading, hasRole, canRead, canWrite } = useUser();
    console.log('User', user);
    console.log('Loading', loading);
    console.log('HasRole', hasRole);
    console.log('Can Read', canRead);
    console.log('Can Write', canWrite);

    if (!user) return null;

    return (
        <div className="app-header__user-info">
            <span className="app-header__user">
                <Icon 
                    name="user-profile" 
                    size="small" /> 
                <strong>{user.alias}</strong>
            </span>
            <Badge color="blue" style={badgeStyles}>{getDisplayRole(user.permissions)}</Badge>
        </div>
    );
};

export default UserInfo;
